const JoinCTA = () => {
    return <span>The system could not match your information to a constituent with an active volunteer history, please contact Bill Bond at <a href="mailto:wbond@ducks.org">wbond@ducks.org</a> with the email and name you used to set up your account, and your chapter information.</span>
};

export default JoinCTA;
